import  React from 'react';
import { EmdgThreadsController } from '../controllers/EmdgThreadsController';
import { ThreadDetail } from '../models/ThreadDetail';
import { ISupportSpinner } from '../shared/Ajax';

export interface ThreadsPageProps { }

export interface ThreadsPageState {
    threadDetail: ThreadDetail
    loginInProgress: boolean
}

export class ThreadsPage extends React.Component<ThreadsPageProps, ThreadsPageState> implements ISupportSpinner {
    ajax: EmdgThreadsController

    constructor(props: ThreadsPageProps) {
        super(props);

        this.ajax = new EmdgThreadsController();

        this.state = {
            threadDetail: {
                availableThreadCount: 0,
                maxThreadCount: 0,
                minThreadCount: 0
            },
            loginInProgress: false
        }
    }

    componentDidMount() {
        this.ajax.getThreadDetails(null, s => {
            this.setState({ threadDetail: s })
        });
    }

    toggleSpinner(on: boolean, callback: { (): any }) {
        this.setState({ loginInProgress: on }, callback);
    }

    render() {
        return <div className="container-fluid pt-4" style={{ minHeight: "300px" }}>
            <h2>Threads</h2>
            <ul>
                <li>
                    Available Threads {this.state.threadDetail.availableThreadCount}
                </li>
                <li>
                    Max Thread Count: {this.state.threadDetail.maxThreadCount}
                </li>
                <li>
                    Min Thread Count: {this.state.threadDetail.minThreadCount}
                </li>
            </ul>
        </div>

    }
}